var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader-inner ball-scale"},[_c('div')])]),_c('div',{staticClass:"loader-text",staticStyle:{"color":"#279fcf"}},[_vm._v("正在加载中...")])])
}]

export { render, staticRenderFns }